import React from "react";
import DialogueOverlay from "components/UI/DialogueOverlay";
import AmenityBox from "../AmenityBox";
import Button from "components/UI/Button";

const mContent = (data, tap, isPrimaryAmenity, selectedIds) => {
  let ModalContent = (
    <h1 style={{ margin: "auto", padding: "5rem", color: "var(--primary)" }}>
      No More Amenities In the Class!
    </h1>
  );

  if (data.length > 0) {
    const modalItems = data.map(currentItem => (
      <AmenityBox
        isPrimaryAmenity={isPrimaryAmenity}
        selected={selectedIds.includes(currentItem.id)}
        key={currentItem.id}
        label={currentItem.name}
        source={currentItem.icons.black}
        onClick={() => {
          tap(currentItem.id);
        }}
      />
    ));

    ModalContent = (
      <div
        style={{
          width: "70vw",
          display: "grid",
          gridTemplateColumns: "repeat(4, 1fr)"
        }}
      >
        {modalItems}
      </div>
    );
  }

  return ModalContent;
};
class AmenitiesAddModal extends React.Component {
  state = {
    selectedIds: []
  };

  tap = id => {
    if(this.props.isPrimaryAmenity) {
      this.setState({selectedIds: [id]})
    } else {
      let selectedIds = [...this.state.selectedIds];
      if (selectedIds.indexOf(id) === -1) selectedIds = [...selectedIds, id];
      else selectedIds = selectedIds.filter(i => i !== id);
      this.setState({ selectedIds });
    }
  };

  render() {
    return (
      <DialogueOverlay>
        {mContent(this.props.data, this.tap, this.props.isPrimaryAmenity, this.state.selectedIds)}
        <div style={{ width: "10vw", margin: "auto" }}>
          <Button
            type="primary"
            onClick={() => {
              this.props.add(this.state.selectedIds);
            }}
          >
            Add
          </Button>
        </div>
      </DialogueOverlay>
    );
  }
}

export default AmenitiesAddModal;
